import React from "react";
import Typography from "material-ui/Typography";
import Grid from "material-ui/Grid";
import TextField from "material-ui/TextField";
import Icon from "material-ui/Icon";
import IconButton from "material-ui/IconButton";
import Button from "material-ui/Button";
import Content from "../ui/content";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import ConfirmDialog from "../common/dialog/confirm";
import Title from "../ui/title";
import Back from "../ui/back";
import NoData from "../nodata";
import BackCheck from "../ui/backCheck";
import { withRouter } from "react-router-dom";
import { validateTargetData } from "../../common/formtool";

class Targets extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ipvErrors: this.props.ipvErrors ? this.props.ipvErrors : {},
      logo: null,
      selectedTest: "",
      searchModal: null,
      oldSelectedTargetId: null,
      showConfirmDelete: false,
      showConfirmBack: false,
      deleteTargetKey: null,
      customerTargets: this.props.isEditCustomer
        ? this.props.customerTargets
        : [],
      isCustomerPage: window.location.href.includes("customer") ? true : false,
      isUpdated: false,
      subTestIpvUpdated: this.props.subTestIpvUpdated
    };
    this.onChange = this.onChange.bind(this);
    this.hideConfirmModal = this.hideConfirmModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onBackClick = this.onBackClick.bind(this);
    this.onBackYesClick = this.onBackYesClick.bind(this);
    this.onBackNoClick = this.onBackNoClick.bind(this);
    this.hideBackConfirmModal = this.hideBackConfirmModal.bind(this);
  }
  componentWillMount() {
    if (!this.state.isCustomerPage) {
      if (window.location.href.includes("ipv4"))
        this.props.getCustTargets4(null);
      else this.props.getCustTargets6(null);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { customerTargets, ipvErrors, selectedTest } = nextProps;
    if (this.props.isEditCustomer) {
      const { customerTargets, subTestIpvUpdated, ipvErrors } = nextProps;
      if (customerTargets) {
        this.setState({
          customerTargets,
          ipvErrors
        });
        return;
      }
      this.setState({ subTestIpvUpdated: subTestIpvUpdated });
    } else {
      if (
        customerTargets &&
        this.props.customerTargets != customerTargets &&
        selectedTest == this.props.match.params.cid
      ) {
        this.setState({
          customerTargets,
          selectedTest,
          ipvErrors
        });
        return;
      }
    }
  }

  onChange = keyValue => e => {
    if (this.props.isEditCustomer) {
      this.props.editTarget(
        e.target.value,
        keyValue,
        e.target.id ? e.target.id : null
      );
      this.setState({ isUpdated: true });
    } else {
      const { translate } = this.props;
      const { selectedTest } = this.state;
      let customerTargets = [...this.state.customerTargets];
      let vObj = {};
      let ipvErrors = { ...this.state.ipvErrors };
      customerTargets[keyValue].url = e.target.value;
      vObj[keyValue] = {
        maxLength: {
          value: 256,
          message: translate("subtest_target_length_validation", {
            value: 256
          })
        }
      };
      let ipvError = validateTargetData(
        this.state.customerTargets,
        vObj,
        selectedTest
      );
      if (Object.keys(ipvError).length) {
        ipvErrors = {
          ...ipvErrors,
          [keyValue]: ipvError[keyValue]
        };
        this.setState({ ipvErrors, customerTargets, isUpdated: false });
      } else {
        ipvErrors = {
          ...ipvErrors,
          [keyValue]: false
        };
        this.setState({
          customerTargets,
          ipvErrors,
          isUpdated: true
        });
      }
    }
  };

  onTargetDelete = key => {
    this.setState({ showConfirmDelete: true, deleteTargetKey: key });
  };

  onTargetConfirmDelete = () => {
    if (this.props.isEditCustomer) {
      this.props.deleteTarget(this.state.deleteTargetKey);
    } else {
      const { deleteTargetKey, selectedTest } = this.state;
      let customerTargets = this.state.customerTargets;
      customerTargets.splice(deleteTargetKey, 1);
      this.setState({
        customerTargets,
        ipvErrors: {},
        isUpdated: true
      });
    }
    this.hideConfirmModal();
    this.setState({ isUpdated: true });
  };

  hideConfirmModal() {
    this.setState({
      showConfirmDelete: false
    });
  }
  onTargetAdd = () => {
    if (this.props.isEditCustomer) {
      this.props.addTarget();
      this.setState({ isUpdated: true });
    } else {
      let customerTargets = this.state.customerTargets;
      customerTargets.push({ url: null });
      this.setState({
        customerTargets,
        errors: {},
        isUpdated: true
      });
    }
  };
  handleSubmit = () => {
    if (this.props.isEditCustomer) {
      this.props.saveTargets(this.customerTargets);
    } else {
      const { selectedTest } = this.state;
      const { translate } = this.props;
      let vObj2 = {};
      let ipvErrors;
      switch (selectedTest) {
        case "ipv4":
          this.state.customerTargets.forEach(function(item, index) {
            vObj2[index] = {
              required: translate("formfield_error_general_required"),
              maxLength: {
                value: 256,
                message: translate("subtest_target_length_validation", {
                  value: 256
                })
              }
            };
          });
          ipvErrors = validateTargetData(
            this.state.customerTargets,
            vObj2,
            selectedTest
          );
          if (Object.keys(ipvErrors).length) {
            this.setState({ ipvErrors: ipvErrors });
          } else {
            let self = this;
            this.props.updateCustTargets4(null, this.state.customerTargets);
            this.setState({ isUpdated: false });
          }

          break;
        case "ipv6":
          this.state.customerTargets.forEach(function(item, index) {
            vObj2[index] = {
              required: translate("formfield_error_general_required"),
              maxLength: {
                value: 256,
                message: translate("subtest_target_length_validation", {
                  value: 256
                })
              }
            };
          });
          ipvErrors = validateTargetData(
            this.state.customerTargets,
            vObj2,
            selectedTest
          );
          if (Object.keys(ipvErrors).length) {
            this.setState({ ipvErrors: ipvErrors });
          } else {
            let self = this;
            this.props.updateCustTargets6(null, this.state.customerTargets);
            this.setState({ isUpdated: false });
          }

          break;
      }
    }
  };

  onBackClick = () => {
    if (this.state.isUpdated) {
      this.setState({
        showConfirmBack: true
      });
    }
  };
  onBackYesClick = () => {
    this.handleSubmit();
    this.setState({
      showConfirmBack: false
    });
  };
  onBackNoClick = () => {
    this.setState({
      customerTargets: null
    });
    this.props.history.push("/subtestsettings");
  };
  hideBackConfirmModal = () => {
    this.setState({
      showConfirmBack: false
    });
  };

  render() {
    const {
      translate,
      classes,
      languages,
      selectedTest,
      isEditCustomer
    } = this.props;
    const {
      customerTargets,
      isUpdated,
      deleteTargetKey,
      ipvErrors
    } = this.state;

    return (
      <div style={{marginTop: "215px"}}>
        {!isEditCustomer ? (
          <Title
            back={
              !isUpdated && (
                <Back
                  link={"/subtestsettings"}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            backCheck={
              isUpdated && (
                <BackCheck
                  toCheck={this.onBackClick}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            title={
              selectedTest === "ipv4"
                ? translate("general_sub_test_ipv4_breadcrumb")
                : translate("general_sub_test_ipv6_breadcrumb")
            }
          />
        ) : null}

        <Content translate={translate}>
          <div className={classes.mainBody}>
            {isEditCustomer ? (
              <Typography type="subheading" className={classes.lengthText}>
                {translate("cust_tab_target_sub_head")}
              </Typography>
            ) : null}
            {customerTargets && customerTargets.length == 10 ? (
              <Typography type="subheading" className={classes.lengthText}>
                {translate("target_limit_validation_text", { limit: 10 })}
              </Typography>
            ) : null}
            <div className={classes.targetHeading}>
              <Typography type="subheading" className={classes.modalHeader}>
                {translate("cust_tab_target_head")}
              </Typography>

              <Button
                color="primary"
                onClick={() => this.onTargetAdd()}
                disabled={customerTargets && customerTargets.length == 10}
              >
                <Icon> add </Icon> {translate("subset_ping_add_target")}
              </Button>
            </div>
            {customerTargets && customerTargets.length > 0 ? (
              customerTargets.map((item, key) => {
                //let nos = key + 1;
                return (
                  <div>
                    <TextField
                      className={classes.textFieldR}
                      // error={errors.contactfirstname}
                      key={key}
                      id={item.id}
                      name={item.id}
                      label={
                        translate("sub_set_ping_target") +
                        " " +
                        (key + 1).toString().padStart(2, "0")
                      }
                      margin="normal"
                      placeholder={translate("sub_set_ping_target")}
                      value={item.url ? item.url : ""}
                      onChange={this.onChange(key)}
                      error={ipvErrors && ipvErrors[key] ? true : false}
                      helperText={
                        ipvErrors && ipvErrors[key] ? ipvErrors[key] : ""
                      }
                    />
                    <IconButton
                      color="primary"
                      id={item.id}
                      onClick={() => this.onTargetDelete(key)}
                    >
                      <Icon> delete </Icon>
                    </IconButton>
                  </div>
                );
              })
            ) : (
              <NoData
                translate={translate}
                noDataText="general_sub_test_no_data_target_text"
              />
            )}
            {!isEditCustomer ? (
              <Button
                raised
                color="primary"
                className={classes.submit}
                onClick={this.handleSubmit}
                type="submit"
                disabled={!isUpdated}
              >
                {translate("general_submit")}
              </Button>
            ) : null}
            <ConfirmDialog
              open={this.state.showConfirmDelete}
              title={translate("sub_test_ipv_delete_confirm_title", {
                name: selectedTest
              })}
              contentText={
                this.state.customerTargets &&
                this.state.customerTargets[deleteTargetKey] &&
                this.state.customerTargets[deleteTargetKey].url &&
                this.state.customerTargets[deleteTargetKey].url.length > 0
                  ? translate("sub_test_delete_confirm_text", {
                      url: this.state.customerTargets[deleteTargetKey].url
                    })
                  : translate("sub_test_delete_empty_confirm_text")
              }
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.onTargetConfirmDelete}
              onCancel={this.hideConfirmModal}
            />
            <ConfirmDialog
              open={this.state.showConfirmBack}
              title={translate("sub_test_ipv_back_confirm_title", {
                name: selectedTest
              })}
              contentText={translate("sub_test_go_back_confirm_text")}
              //okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              //onOk={this.onTargetConfirmDelete}
              onCancel={this.hideBackConfirmModal}
              yesText={translate("back_btn_yes")}
              noText={translate("back_btn_no")}
              backText={translate("back_btn_go_back")}
              onYes={this.onBackYesClick}
              onNo={this.onBackNoClick}
              onBack={this.hideBackConfirmModal}
            />
          </div>
        </Content>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(Targets));
